import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import EquipmentParameterForm from "components/equipments/parameters/EquipmentParameterForm";
import { updateEquipmentParameter } from "graphql/mutations";
import {
  equipmentParametersByEquipmentID,
  getEquipment,
  getEquipmentParameter,
} from "graphql/queries";

const EquipmentParameterUpdateForm = ({
  equipmentID,
  equipmentParameterId,
  onSuccess,
}) => {
  const navigate = useNavigate();
  const [equipmentParameter, setEquipmentParameter] = useState();
  const [companyID, setCompanyID] = useState("");

  async function onSubmit(valuesParam) {
    try {
      const { parameterID, parameterName, parameterValue } = valuesParam;

      if (equipmentParameter.parameterID !== parameterID) {
        const oldEquipmentParameterData = await API.graphql(
          graphqlOperation(equipmentParametersByEquipmentID, {
            equipmentID: equipmentParameter.equipmentID,
            filter: {
              and: [
                {
                  parameterID: { eq: parameterID },
                },
              ],
              deletedAt: { attributeExists: false },
            },
          })
        );
        const oldEquipmentParameterItems =
          oldEquipmentParameterData.data.equipmentParametersByEquipmentID.items;

        if (oldEquipmentParameterItems.length > 0) {
          toast.error(strings.parameterExists);
          return;
        }
      }

      await API.graphql({
        query: updateEquipmentParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            id: equipmentParameterId,
            parameterID,
            parameterName,
            parameterValue,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/equipments");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchEquipmentParameter(id) {
    try {
      const equipmentParameterData = await API.graphql(
        graphqlOperation(getEquipmentParameter, { id })
      );
      const equipmentParameterItem =
        equipmentParameterData.data.getEquipmentParameter;
      if (!equipmentParameterItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/equipments");
        return;
      }
      setEquipmentParameter({
        ...equipmentParameterItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  async function getCompanyFromEquipment(id) {
    try {
      const equipmentData = await API.graphql(
        graphqlOperation(getEquipment, { id })
      );
      const equipmentItem = equipmentData.data.getEquipment;
      if (!equipmentItem) {
        toast.error(strings.responses.errorFetchEquipment);
        return;
      }
      setCompanyID(equipmentItem.companyID);
    } catch (err) {
      toast.error(strings.responses.errorFetchEquipment);
    }
  }

  useEffect(() => {
    fetchEquipmentParameter(equipmentParameterId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentParameterId]);

  useEffect(() => {
    getCompanyFromEquipment(equipmentID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentID]);

  if (!equipmentParameter || !companyID) return <Loader />;

  return (
    <div>
      <EquipmentParameterForm
        onSubmit={onSubmit}
        type="update"
        initialValues={equipmentParameter}
        companyID={companyID}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Parámetro de Equipo",
    successUpdated: "Parámetro de Equipo actualizado con éxito",
    parameterExists: "El parámetro ya existe en el equipo",
    responses: {
      errorFetch: "Error al consultar el parámetro de equipo",
      errorFetchEquipment: "Error al consultar equipo",
    },
  },
});

export default EquipmentParameterUpdateForm;
